// CloudinaryUpload.js
export async function uploadToCloudinary(file, options = {}, retries = 3) {
  // Add this check at the beginning
  if (!file) {
    throw new Error("No file provided for upload");
  }

  // Validate file - now accepting data URLs, Blob, or File
  if (!(file instanceof Blob || file instanceof File || typeof file === 'string')) {
    throw new Error("Invalid file provided for upload - must be Blob, File, or data URL string");
  }

  const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || "dwfdzdaxk";
  const uploadPreset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || "farmnet";

  const formData = new FormData();
  
  // Handle data URL conversion to Blob
  let fileToUpload = file;
  if (typeof file === 'string' && file.startsWith('data:')) {
    try {
      const response = await fetch(file);
      const blob = await response.blob();
      fileToUpload = blob;
    } catch (error) {
      throw new Error(`Failed to convert data URL to Blob: ${error.message}`);
    }
  }
  
  formData.append('file', fileToUpload);
  formData.append('upload_preset', uploadPreset);
  
  // Add optional parameters
  if (options.folder) {
    formData.append('folder', options.folder);
  }
  if (options.userId) {
    formData.append('tags', `user_${options.userId}`);
  }

  const endpoint = `https://api.cloudinary.com/v1_1/${cloudName}/upload`;

  for (let i = 0; i < retries; i++) {
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error?.message || `Upload failed with status ${response.status}`);
      }

      return await response.json();
      
    } catch (error) {
      if (i === retries - 1) {
        console.error('Final upload error:', error);
        throw new Error(`Upload failed: ${error.message}`);
      }
      await new Promise(resolve => setTimeout(resolve, 1000 * (i + 1)));
    }
  }
}